<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'VINCULACIONTERCERO.LBL_CONFMENU' | translate}}</h1>
  </div>
</div>
<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-card>
        <h2>{{menuVinculacion.nombreTipoVinculacion}}</h2>
      </p-card>
    </div>
  </div>
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idForm" name="nomForm">
    <div class="grid">
      <div class="col-12 md:col-4 lg:col-4 md:col-offset-1 lg:col-offset-1">
        <label>{{'VINCULACIONTERCERO.LBL_TIPOOCUPACION' | translate}}:</label>
        <p-dropdown disableTab  id="idTipoOcupacion" name="nomIdTipoOcupacion" [options]="lisTipoOcupaciones"
                    placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                     formControlName="idTipoOcupacion"
        ></p-dropdown>
        <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idTipoOcupacion.invalid">
          {{ 'VINCULACIONTERCERO.LBL_TIPOOCUPACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                type="submit"
                pButton></button>
      </div>
    </div>
  </form>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #dtpreguntas [loading]="carTabla"
               [value]="listarHabilitados()" selectionMode="single" dataKey="idCuestionarioPregunta"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-index="rowIndex">
          <tr [pSelectableRow]="row">
            <td>{{row.tipoOcupacion}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash-o" data-toggle="tooltip"
                        title="{{'BTN_ELIMINAR' | translate}}" pButton
                        (click)="eliminar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <div>
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar()"
              pButton></button>
    </div>
  </div>
</div>


<p-confirmDialog #cd key="pregunta">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
